export default __webpack_public_path__ + "4daf53db49916007377584c01d9e57e7.png";